import { TFunction } from 'i18next'
import { boolean, object, SchemaOf } from 'yup'

import { User } from '@modules-deprecated/app/user'

export interface UserPrivacyForm {
  isSupportAccessAllowed: boolean
}

export type UserPrivacyFormSchema = SchemaOf<UserPrivacyForm>

export const getValidationSchema = (t: TFunction): UserPrivacyFormSchema =>
  object({
    isSupportAccessAllowed: boolean().required(),
  })

interface GetDefaultValuesOptions {
  user?: User
}

export const getDefaultValues = ({ user }: GetDefaultValuesOptions): UserPrivacyForm => ({
  isSupportAccessAllowed: user?.isSupportAccessAllowed || false,
})
